import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from 'i18next-http-backend';

const options = {
    order: ['querystring', 'localStorage'],
}

export const configurei18n = (Config) => {
    i18n.use(Backend).use(LanguageDetector).init({
        detection: options,
        load: 'languageOnly',
        //defaultNS: Config.language_default,
        lng: localStorage.getItem("i18nextLng") || Config.language_default,
        backend: {
            loadPath: './locales/{{lng}}/translation.json?ts=' + new Date().getTime(),
        },
        fallbackLng: null,
        debug: false,
        react: {
            wait: true,
            useSuspense: true
        },
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },
        getAsync: false
    });
}

export default i18n